module.exports = __webpack_public_path__ + "static/img/orderStatusExpTime.dda6387.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/orderStatusExpTime.png
// module id = GrYD
// module chunks = 1